import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../../theme/hooks/useFeatureTheme';
import { formatChartTickValue } from '../../utils/chartFormatUtils';

const KPI_LABELS = {
  count: 'Record count',
};

export default function KpiCard({ value, label, comparison, compact = false }) {
  const { semantic, typography } = useFeatureTheme();
  const displayValue = formatChartTickValue(value);
  const displayLabel = KPI_LABELS[label] || label;
  const direction = comparison?.direction;
  const comparisonColor = direction === 'up'
    ? semantic.states.success
    : direction === 'down'
      ? semantic.states.danger
      : semantic.text.secondary;

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: compact ? 3 : 4,
        px: 2,
      }}
    >
      <Typography
        variant={compact ? 'h3' : 'h2'}
        sx={{ fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.1 }}
      >
        {displayValue || '—'}
      </Typography>
      {label ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontWeight: 500 }}>
          {displayLabel}
        </Typography>
      ) : null}
      {comparison?.text ? (
        <Typography
          sx={{
            mt: 0.75,
            fontSize: typography.fontSizeSm,
            fontWeight: typography.fontWeightMedium,
            color: comparisonColor,
          }}
        >
          {comparison.text}
        </Typography>
      ) : null}
    </Box>
  );
}
